var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 106,
    viewBox: "0 0 108 106",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h108v106H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 91c0-2.209-24.177-4-54-4S0 88.791 0 91s24.177 4 54 4 54-1.791 54-4",
    fill: "#E5E8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.163 23C7.983 23 7 23.99 7 25.178v56.644C7 83.01 7.984 84 9.163 84h88.674c1.18 0 2.163-.99 2.163-2.178V25.178C100 23.99 99.016 23 97.837 23H9.163zm.608 2.178h87.458l-43.73 37.75L9.772 25.176v.002zm-.608 2.349 28.116 24.305L9.163 80.153V27.527zm88.674 0v52.626L69.721 51.832l28.116-24.305zM38.97 53.262 52.79 65.21a1.076 1.076 0 0 0 1.42 0l13.822-11.948L96.384 81.82H10.615l28.352-28.558h.002zM9.163 81.719l.101.103h-.101v-.103zm88.674 0v.103h-.101l.101-.103z",
    stroke: "#FFF",
    strokeWidth: 0.5,
    fill: "#272C4D",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.3784cd35a7eba3729ab3e140d73e50dd.svg";
export { ForwardRef as ReactComponent };